// Safely ensure the app namespace exists.
var app = app || {};
